export let userLang = (navigator.language || navigator.userLanguage).slice(0, 2);
if((userLang !== "en") && (userLang !== "ru") && (userLang !== "es")){
    userLang = "en";
}